import { render, staticRenderFns } from "./galleryForm.vue?vue&type=template&id=230ec56a&"
import script from "./galleryForm.vue?vue&type=script&lang=js&"
export * from "./galleryForm.vue?vue&type=script&lang=js&"
import style0 from "./galleryForm.vue?vue&type=style&index=0&id=230ec56a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports